// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProposalPopup_inputHint__4BwV4 {
  font: var(--body-font-three);
  color: #8692A4;
  margin-bottom: var(--spacing-sm, 8px);
}

.ProposalPopup_inputBox__-CRfY {
  max-width: 80%;
  margin: 24px auto;
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .ProposalPopup_inputBox__-CRfY {
    max-width: 100%;
    margin: 18px auto;
    margin-bottom: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VendorTracker/modal/ProposalPopup.module.scss"],"names":[],"mappings":"AAAA;EACC,4BAAA;EACA,cAAA;EACA,qCAAA;AACD;;AAEA;EACC,cAAA;EACA,iBAAA;EACA,gBAAA;AACD;AACC;EALD;IAME,eAAA;IACA,iBAAA;IACA,mBAAA;EAEA;AACF","sourcesContent":[".inputHint {\r\n\tfont: var(--body-font-three);\r\n\tcolor: #8692A4;\r\n\tmargin-bottom: var(--spacing-sm, 8px);\r\n}\r\n\r\n.inputBox {\r\n\tmax-width: 80%;\r\n\tmargin: 24px auto;\r\n\tmargin-bottom: 0;\r\n\t\r\n\t@media (max-width: 768px) {\r\n\t\tmax-width: 100%;\r\n\t\tmargin: 18px auto;\r\n\t\tmargin-bottom: 18px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputHint": `ProposalPopup_inputHint__4BwV4`,
	"inputBox": `ProposalPopup_inputBox__-CRfY`
};
export default ___CSS_LOADER_EXPORT___;
